<template>
  <div>
    <splitpanes class="default-theme">
      <pane size="50" min-size="25">
        <DocumentList
          :key="documentListKey"
          :searchType="searchType"
          :searchPattern="searchPattern"
        />
      </pane>
      <pane size="50" min-size="50">
        <DocumentViewer />
      </pane>
    </splitpanes>
  </div>
</template>

<script>
import DocumentList from "@/components/search/results/list/DocumentList";
import DocumentViewer from "@/components/search/results/DocumentViewer";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

export default {
  components: {
    DocumentList,
    DocumentViewer,
    Splitpanes,
    Pane
  },
  data() {
    return {
      documentListKey: 0,
      searchType: "",
      searchPattern: ""
    };
  },
  created() {
    this.searchType = this.$route.params.search_type;
    this.searchPattern = this.$route.params.search_pattern;
  },

  mounted() {
    // try {
    //   const { clientHeight } = document.getElementsByClassName(
    //     "v-content__wrap"
    //   );
    //   this.domHeight = clientHeight;
    //   console.log(clientHeight);
    // } catch (err) {
    //   this.domHeight = 600;
    //   console.log("pdf err", err);
    // }
  },
  beforeRouteUpdate(to, from, next) {
    this.searchType = to.params.search_type;
    this.searchPattern = to.params.search_pattern;
    this.documentListKey += 1;
    next();
  }
};
</script>
